import polyfillContains from '../common/polyfills/Node/prototype/contains';
import 'jspolyfill-array.prototype.find';
import 'jspolyfill-array.prototype.findIndex';
import { PermissionClient } from './app/permission-client-app';
import * as Logger from '../common/tools/logger';

polyfillContains();

const client = new PermissionClient();

/* istanbul ignore next else */
if (window.PermissionClient && window.PermissionClient.q) {
  // apply arguments from a queued init() call that was made before this library was loaded.
  const initArgs: IArguments = window.PermissionClient.q;
  window.PermissionClient = client;
  Logger.debug('PermissionClient async startup: Applying queued init arguments');
  client.init(...[].slice.call(initArgs));
}

export default client;
